import { stripMarkdownToText } from "~/lib/stripMarkdownToText";
import { SnippetText } from "~/pages/manifold-nextgen/components/search-manager/SnippetText";
import { SearchHit } from "~/services/search";
import { markTerms, plainSnippet } from "./plainSnippet";
import { HitDetails } from "./useHitDetails";

interface HitPreviewProps {
  hit: SearchHit;
  details: HitDetails | undefined;
  query: string;
}

/**
 * The text a hit matched on, as plain text. A hit matched on meaning alone has
 * no snippet, so its description stands in, marked where it contains the query.
 */
export const HitPreview = ({ hit, details, query }: HitPreviewProps) => {
  const snippet = hit.snippet ? plainSnippet(hit.snippet) : "";
  if (snippet) {
    // `ts_headline` over the indexed text, so its emphasis marks real matches.
    return <SnippetText snippet={snippet} />;
  }
  const description = details?.description ? stripMarkdownToText(details.description) : "";
  return description ? <SnippetText snippet={markTerms(description, query)} /> : null;
};
